// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3Ni3T","question":"Question_question__2PqvP","description":"Question_description__12kaI"};